import { Swiper } from 'swiper';
import { Navigation, Pagination, A11y, EffectFade } from 'swiper/modules';

import 'swiper/css';

const sectionTestimonials = document.querySelectorAll('section.testimonials');

document.addEventListener('DOMContentLoaded', () => {
	sectionTestimonials.forEach((section) => {
		if(section.querySelector('.testimonials-wrapper')) {
			const sectionId = section.getAttribute('id');
			const swiperId = `#${sectionId} .swiper`;

			new Swiper(swiperId, {
				modules: [ Navigation, Pagination, A11y, EffectFade ],
				speed: 700,
				autoplay: {
					delay: 5000,
					pauseOnMouseEnter: true,
				},
				slidesPerView: 1,
				spaceBetween: 32,
				autoHeight: true,
				loop: true,
				effect: 'fade',
				navigation: {
          nextEl: `#${sectionId} .swiper-btn-next`,
          prevEl: `#${sectionId} .swiper-btn-prev`,
        },
			});
		}
	});
});
